module.exports = __webpack_public_path__ + "static/img/22.0e2a6500.png";